import React, { useContext, useEffect } from 'react';
import { ReactSVG } from 'react-svg';
import { useHistory } from 'react-router';
import { useIntl } from 'react-intl';
import check from '../../assets/image/welcome/check.svg';
import { hideEmail } from '../../utils/helpers';
import storage from '../../utils/storage';
import { appStore } from '../../state/app';
import { checkingLogin } from '../../utils/login';

const ReadyPage = () => {
  const history = useHistory();
  const { state, update } = useContext(appStore);
  const { wallet, account } = state;
  const translate = useIntl();

  useEffect(() => {
    if (wallet && wallet.signedIn) {
      storage.set('isSignIn', true);
      checkingLogin(account, history, () => {}, false, update);
    } else if (!storage.get('emailUser')) {
      return history.push('/create-project');
    }
  }, [wallet]);

  return (
    <div className="ready-page">
      <div className="pending-validation">
        <div className="pending-validation__description">
          <ReactSVG
            src={check}
            className="pending-validation__image"
          />
          <h3 className="pending-validation__title">
            {translate.formatMessage({ id: 'readyPage.title' })}
          </h3>
          <p className="pending-validation__text">
            {translate.formatMessage({ id: 'readyPage.validation-text' })}
          </p>
        </div>
        <div className="pending-validation__accountBlock">
          <p className="pending-validation__accountBlock-text">
            {translate.formatMessage({ id: 'readyPage.account' })}
          </p>
          <p className="pending-validation__accountBlock-text">
            {translate.formatMessage({ id: 'readyPage.status' })}
          </p>
          <p className="pending-validation__accountBlock-email">
            {hideEmail(storage.get('emailUser') || '')}
          </p>
          <p className="pending-validation__accountBlock-status">
            {translate.formatMessage({ id: 'readyPage.pending' })}
          </p>
        </div>
      </div>
    </div>
  );
};

export default ReadyPage;
